// components/DashboardContent.jsx
import React from "react";
import {
  FaFileAlt,
  FaChartLine,
  FaChartBar,
  FaChartPie,
  FaExclamationTriangle,
} from "react-icons/fa";

const reportIssues = [
  {
    company: "Apple Inc. (AAPL)",
    missingReport: "Cash Flow Statement PDF",
    accuracy: 92,
    status: "Missing",
  },
  {
    company: "Microsoft (MSFT)",
    missingReport: "Balance Sheet PDF",
    accuracy: 88,
    status: "Missing",
  },
  {
    company: "Amazon (AMZN)",
    missingReport: "Income Statement PDF",
    accuracy: 96,
    status: "Completed",
  },
];

const DashboardContent = () => {
  return (
    <div className="p-6">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="text-center mb-8">
          <h1 className="text-2xl font-bold text-gray-900 dark:text-white">
            Dashboard
          </h1>
          <p className="text-gray-600 dark:text-gray-400 mt-2">
            View analytics and reports for your financial data
          </p>
        </div>

        {/* Stats Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
          <div className="bg-white dark:bg-gray-800 rounded-xl shadow p-6">
            <div className="flex justify-between items-center">
              <div>
                <p className="text-sm text-gray-500">Total Reports</p>
                <h3 className="text-2xl font-bold">24</h3>
              </div>
              <FaFileAlt className="text-3xl text-blue-500" />
            </div>
          </div>

          <div className="bg-white dark:bg-gray-800 rounded-xl shadow p-6">
            <div className="flex justify-between items-center">
              <div>
                <p className="text-sm text-gray-500">Revenue Growth</p>
                <h3 className="text-2xl font-bold text-green-600">+12.5%</h3>
              </div>
              <FaChartLine className="text-3xl text-green-500" />
            </div>
          </div>

          <div className="bg-white dark:bg-gray-800 rounded-xl shadow p-6">
            <div className="flex justify-between items-center">
              <div>
                <p className="text-sm text-gray-500">Companies Analyzed</p>
                <h3 className="text-2xl font-bold">156</h3>
              </div>
              <FaChartBar className="text-3xl text-purple-500" />
            </div>
          </div>

          <div className="bg-white dark:bg-gray-800 rounded-xl shadow p-6">
            <div className="flex justify-between items-center">
              <div>
                <p className="text-sm text-gray-500">Accuracy Rate</p>
                <h3 className="text-2xl font-bold text-orange-500">94.7%</h3>
              </div>
              <FaChartPie className="text-3xl text-orange-500" />
            </div>
          </div>
        </div>

        {/* Report Issues Section */}
        <div className="bg-white dark:bg-gray-800 rounded-xl shadow-lg p-6 mb-8">
          <div className="flex items-center gap-2 mb-4">
            <FaExclamationTriangle className="text-red-500" />
            <h3 className="text-lg font-semibold text-gray-900 dark:text-white">
              Report Issues Summary
            </h3>
          </div>

          <div className="overflow-x-auto">
            <table className="min-w-full divide-y divide-gray-200 dark:divide-gray-700">
              <thead>
                <tr>
                  <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">
                    Company
                  </th>
                  <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">
                    Missing Report
                  </th>
                  <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">
                    Accuracy
                  </th>
                  <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">
                    Status
                  </th>
                </tr>
              </thead>

              <tbody className="divide-y divide-gray-200 dark:divide-gray-700">
                {reportIssues.map((item, index) => (
                  <tr key={index}>
                    <td className="px-4 py-3 text-sm font-medium">
                      {item.company}
                    </td>
                    <td className="px-4 py-3 text-sm text-gray-600 dark:text-gray-400">
                      {item.missingReport}
                    </td>
                    <td className="px-4 py-3 text-sm">
                      <span
                        className={`font-semibold ${
                          item.accuracy >= 90
                            ? "text-green-600"
                            : "text-yellow-600"
                        }`}
                      >
                        {item.accuracy}%
                      </span>
                    </td>
                    <td className="px-4 py-3">
                      <span
                        className={`px-2 py-1 text-xs rounded-full font-semibold ${
                          item.status === "Missing"
                            ? "bg-red-100 text-red-700"
                            : "bg-green-100 text-green-700"
                        }`}
                      >
                        {item.status}
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DashboardContent;
